import { SvgIcon } from '@mui/material';
import React, { CSSProperties, ReactElement } from 'react';

export interface CalendarIconProps {
  style?: CSSProperties;
}

export const CalendarIcon = ({ style }: CalendarIconProps): ReactElement => {
  return (
    <SvgIcon
      style={{
        fontSize: '1em',
        color: '#383838',
        ...style,
      }}
      viewBox="0 0 16 19"
    >
      <path
        d="M1.6155 18.2307C1.15517 18.2307 0.770833 18.0766 0.4625 17.7682C0.154167 17.4599 0 17.0756 0 16.6152V3.84625C0 3.38592 0.154167 3.00158 0.4625 2.69325C0.770833 2.38492 1.15517 2.23075 1.6155 2.23075H3.3845V0H4.4615V2.23075H11.6155V0H12.6155V2.23075H14.3845C14.8448 2.23075 15.2292 2.38492 15.5375 2.69325C15.8458 3.00158 16 3.38592 16 3.84625V16.6152C16 17.0756 15.8458 17.4599 15.5375 17.7682C15.2292 18.0766 14.8448 18.2307 14.3845 18.2307H1.6155ZM1.6155 17.2307H14.3845C14.5385 17.2307 14.6796 17.1667 14.8077 17.0385C14.9359 16.9103 15 16.7692 15 16.6152V7.84625H1V16.6152C1 16.7692 1.06408 16.9103 1.19225 17.0385C1.32042 17.1667 1.4615 17.2307 1.6155 17.2307ZM1 6.846H15V3.84625C15 3.69225 14.9359 3.55117 14.8077 3.423C14.6796 3.29483 14.5385 3.23075 14.3845 3.23075H1.6155C1.4615 3.23075 1.32042 3.29483 1.19225 3.423C1.06408 3.55117 1 3.69225 1 3.84625V6.846Z"
        fill="#383838"
      />
    </SvgIcon>
  );
};
